import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const TextInput = ({ placeholder, value, onChange, type, error }) => {
  return (
    <div className="main-frame-input">
      <div className={`frame-input ${error !== '' ? 'active-focus' : ''}`}>
        <input
          placeholder={placeholder}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="active"
        />
      </div>
      <div className={`${error ? 'active-error' : 'frame-error'}`}>
        <p>{error}</p>
      </div>
    </div>
  )
}

TextInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  error: PropTypes.string
}

export default TextInput
